// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4896":"4daa431b","7485":"4daa431b","8934":"71a92a04","9075":"4daa431b"}[chunkId] + ".chunk.css";
};